import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { ltrTheme } from "../../Theme";

const useStyles = makeStyles((theme: Theme) => ({
  noOptionsText_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    color: "#E11919",
    fontSize: "16px",
    letterSpacing: 0,
  },
  textField: {
    marginTop: "0 !important",
    marginBottom: "0 !important",
    transform: "translateY(5px)",
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
      boxShadow: (ltrTheme as any).boxShadow.primary,
    },
    "& .MuiInputLabel-root": {
      fontSize: "16px",
      color: "#424242",
      opacity: "0.5",
      letterSpacing: "0",
    },
    "& .MuiInputLabel-shrink": {
      fontSize: "18px",
      fontWeight: "bold",
      marginTop: "8px",
      opacity: 1,
      color: ltrTheme.palette.primary.main,
    },
    "& legend": {
      display: "none",
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      backgroundColor: "#FEE8E8",
      boxShadow: "none",
      "&:hover, &:not(:hover) ": {
        backgroundColor: "#FEE8E8",
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: "2px",
      fontSize: "14px",
      color: "#424242",
      position: "absolute",
      letterSpacing: 0,
      top: "60px",
    },
    "& .MuiFormHelperText-root.Mui-error": {},
  },
  noOptionColor: {
    "& .MuiAutocomplete-noOptions": {
      color: "red !important",
    },
  },
}));

export default useStyles;
